import { css } from '@emotion/react';

const buttonStyles = {
    button: css({
        borderRadius: '9px',
        color: '#000000',
        fontWeight: 600,
        fontSize: '15px',
        lineHeight: '16px',
        letterSpacing: '-0.12px',
        cursor: 'pointer',
    }),
    key: css({
        height: '42px',
        width: '42px',
        border: 'solid 1px #EDEDED',
        backgroundColor: '#EDEDED',
        padding: '12px',
        boxShadow: 'none',
    }),
    link: css({
        boxShadow: 'none',
        border: 'none',
        backgroundColor: 'inherit',
    }),
    black: css({
        border: 'none',
        color: '#FFFFFF',
        backgroundColor: '#000000',
        padding: '15px 25px',
    }),
    primary: css({
        border: 'none',
        // backgroundColor: '#0057B7',
        backgroundColor: '#000000',
        width: '100%',
        color: '#ffffff',
        padding: '15px 25px',
    }),
    disabled: css({
        backgroundColor: '#D1D5DB',
        cursor: 'not-allowed',
        boxShadow: 'none',
    }),
};

export default buttonStyles;
